@let isBrazilBankRegEnabled = userDataService?.userData?.configParams?.isBrazilBankRegEnabled;
<div class="deposit-process">
    @if (isBrazilBankRegEnabled) {
        <show-message [type]="messageType.INFO">
            <div info>
                {{ 'PARTY.CASHIER.web.deposit.qrcode.generator.qrcode.alert' | translate }}
            </div>
        </show-message>
    }
    @if (paymentMethod == 'PIX') {
        <div>
            <div class="pixQrcodeWrapper">
                @if (!isBrazilBankRegEnabled) {
                    <p class="pt-1 txt-md-v2 text-bold">{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.instructions.header' | translate }}</p>
                }
                <div class="qrcode_img d-flex justify-content-center flex-column py-3">
                    @if (!isBrazilBankRegEnabled) {
                        <div>
                            @if (providerNames.includes(providerName)) {
                                <div class="d-flex justify-content-center">
                                    <qrcode [qrdata]="QRcodeImage" [errorCorrectionLevel]="'H'"></qrcode>
                                </div>
                            } @else {
                                <img [src]="QRcodeImage" alt="QRcode Image" class="mx-auto d-flex" />
                            }
                        </div>
                    }
                    <div class="text-center font-weight-bold mt-2">
                        @if (isBrazilBankRegEnabled) {
                            <p class="txt-sm-v2">{{ 'PARTY.CASHIER.web.deposit.bankregistration.pixcode.deposit.amount.label' | translate }}</p>
                        }
                        <p class="txt-xl-v2 font-weight-bold">
                            {{ depositSubmitResponse()?.amount?.value | vnCurrency }}
                        </p>
                        @if (isBrazilBankRegEnabled) {
                            <p class="txt-sm-v2">
                                {{ 'PARTY.CASHIER.web.deposit.bankregistration.pixcode.expires.in.label' | translate }}
                                {{ timerDurationDetails()?.hours }}:{{ timerDurationDetails()?.minutes }}:{{ timerDurationDetails()?.seconds }}
                            </p>
                        } @else {
                            <p class="txt-sm-v2 font-weight-bold timer-txt">
                                {{ timerDurationDetails()?.hours }}:{{ timerDurationDetails()?.minutes }}:{{ timerDurationDetails()?.seconds }}
                            </p>
                        }
                    </div>
                </div>
                <div class="py-2 px-2 qrcode-box mb-3">
                    <p class="txt-sm-v2 mb-1 font-weight-normal copy-code-header">
                        {{ 'PARTY.CASHIER.web.deposit.qrcode.generator.copy.pix.code' | translate }}
                    </p>
                    @if (QRCodeCopiedStatus['ICON_CLICKED']?.isActive) {
                        <div class="tooltip_pix icon_clicked position-relative">
                            <span class="tooltiptext px-2 py-1 text-white position-absolute txt-sm-v2">{{
                                'PARTY.CASHIER.web.deposit.qrcode.generator.notification.copied.code.txt' | translate
                            }}</span>
                        </div>
                    }
                    <div class="d-flex align-items-center qrcode-details">
                        <p class="qrcode py-1 px-2 font-weight-bold txt-sm-v2">{{ depositSubmitResponse()?.postData?.textToQRcode }}</p>
                        <i class="theme-copy-clipboard cursor-pointer" (click)="copyContentToClipboard('ICON_CLICKED')"></i>
                    </div>
                </div>
                @if (isBrazilBankRegEnabled) {
                    <ng-template [ngTemplateOutlet]="copyPixCodeBtn"></ng-template>
                }
                <div class="qrcode-instructions mb-4" [ngClass]="{ 'mt-3': isBrazilBankRegEnabled }">
                    @if (isBrazilBankRegEnabled) {
                        <mat-accordion>
                            <mat-expansion-panel
                                (opened)="expand('showPixQRCode', true)"
                                (closed)="expand('showPixQRCode', false)"
                                [expanded]="showPixQRCode">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <span class="txt-md-v2"
                                            ><b>{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.qrcode.label' | translate }}</b></span
                                        >
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ol class="qrcode_img pl-3 pb-3 txt-sm-v2 remove-space mt-2">
                                    <p class="txt-lg-v2 font-weight-bold text-center">
                                        {{ depositSubmitResponse()?.amount?.value | vnCurrency }}
                                    </p>
                                    @if (providerNames.includes(providerName)) {
                                        <div class="d-flex justify-content-center">
                                            <qrcode [qrdata]="QRcodeImage" [errorCorrectionLevel]="'H'"></qrcode>
                                        </div>
                                    } @else {
                                        <img [src]="QRcodeImage" alt="QRcode Image" class="mx-auto d-flex" />
                                    }
                                </ol>
                            </mat-expansion-panel>
                        </mat-accordion>
                        <hr class="m-0" />
                    }
                    <mat-accordion>
                        <mat-expansion-panel
                            (opened)="expand('showInstructions', true)"
                            (closed)="expand('showInstructions', false)"
                            [expanded]="showInstructions">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span class="txt-md-v2"
                                        ><b>{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.instructions.mobile.header' | translate }}</b></span
                                    >
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ol class="pl-1 txt-sm-v2">
                                <li>{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.mobileinstructions.msg1' | translate }}</li>
                                @if (isBrazilBankRegEnabled) {
                                    <li>{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.mobileinstructions.msg4' | translate }}</li>
                                } @else {
                                    <li>{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.mobileinstructions.msg2' | translate }}</li>
                                }
                                <li>{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.mobileinstructions.msg3' | translate }}</li>
                            </ol>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                @if (!isBrazilBankRegEnabled) {
                    <ng-template [ngTemplateOutlet]="copyPixCodeBtn"></ng-template>
                }
            </div>
        </div>
    }
    @if (isBrazilBankRegEnabled) {
        <div class="text-center pb-2 cursor-pointer" (click)="goToPixProcess()">
            <span class="txt-link text-decoration-none fs-12 font-weight-bold">{{
                'PARTY.CASHIER.web.deposit.qrcode.generator.status.link' | translate
            }}</span>
        </div>
    }
</div>
<ng-template #copyPixCodeBtn>
    @if (QRCodeCopiedStatus['CTA_CLICKED']?.isActive) {
        <div class="tooltip_pix cta_clicked position-relative">
            <span class="tooltiptext px-2 py-1 text-white position-absolute txt-sm-v2">{{
                'PARTY.CASHIER.web.deposit.qrcode.generator.notification.copied.code.txt' | translate
            }}</span>
        </div>
    }
    <button class="btn btn-primary w-100 cursor-pointer" (click)="copyContentToClipboard('CTA_CLICKED')">
        <span class="font-weight-bold">{{ 'PARTY.CASHIER.web.deposit.qrcode.generator.copy.txt' | translate }}</span>
    </button>
</ng-template>
